import { NorthData } from "../viz-base"
import { Callback, getDataDomain } from "./base"
import { json } from "d3-fetch"

export type RequestOptions = {
  apiKey?: string
  immediate?: boolean
  [key: string]: any
}

type Request = {
  options: RequestOptions
  success: Callback
  error: Callback
}

type AggregatedRequest = {
  options: RequestOptions[]
  origin: string
  v: string
}

interface DataSource {
  requestData(options: RequestOptions, success: Callback, error: Callback): void
}

export const dataSource: DataSource = (function () {
  let waitingRequests: Request[] = []

  function requestData(
    options: RequestOptions,
    success: Callback,
    error: Callback
  ): void {
    const request = { options, success, error }
    if (options["immediate"]) {
      executeRequests([request])
    } else {
      waitingRequests.push(request)
      window.setTimeout(executeWaitingRequests)
    }
  }

  function submit(
    apiKey: string | undefined,
    params: AggregatedRequest,
    callback: (err: any, data: any) => void
  ) {
    const detectedDomain = NorthData.options.detectDataDomain
      ? getDataDomain()
      : undefined
    const domain = detectedDomain || NorthData.options.dataDomain
    const baseUrl =
      ((window as any)["dataDomain"] /* undocumented: for CORS testing!*/ ||
        domain) + "/data.json"
    const headers = {
      "Content-Type": "application/json; charset=UTF-8",
      ...(apiKey && { "X-Api-Key": apiKey }),
    }

    if (params.options.length === 1 && params.options[0]["useGet"] === "true") {
      var urlParams = new URLSearchParams()

      Object.keys(params.options[0])
        .filter((key) => key !== "useGet")
        .filter((key) => key !== "apiKey")
        .filter((key) => {
          const value = params.options[0][key]
          return (
            typeof value === "string" ||
            typeof value === "boolean" ||
            typeof value === "number"
          )
        })
        .forEach((key) => {
          urlParams.set(key, params.options[0][key])
        })

      json(`${baseUrl}?${urlParams.toString()}`, {
        headers,
        method: "GET",
      })
        .then((data) => callback(null, data))
        .catch((error) => callback(error, undefined))
      return
    }

    json(baseUrl, {
      headers,
      method: "POST",
      body: JSON.stringify(params),
    })
      .then((data) => callback(null, data))
      .catch((error) => callback(error, undefined))
  }

  function executeRequests(requests: Request[]) {
    const options: RequestOptions[] = []
    let apiKey: string | undefined = undefined
    for (const request of requests) {
      options.push(request.options)
      apiKey = apiKey ?? request.options["apiKey"]
    }
    if (options.length > 0) {
      const params = {
        options,
        origin: document.location.hostname,
        v: NorthData.version,
      }
      submit(apiKey, params, function (error: Error, response) {
        if (error) {
          for (let request of requests) {
            request.error(error.message)
          }
        } else {
          const results = response["result"]
          requests.forEach((request, index) => {
            const result = results[index]
            const error = result.error
            if (error) {
              request.error(error.message)
            } else {
              request.success(result)
            }
          })
        }
      })
    }
  }

  function executeWaitingRequests() {
    executeRequests(waitingRequests)
    waitingRequests = []
  }

  return { requestData }
})()
